export function onlyUnique(value, index, self) {
  return self.indexOf(value) === index
}

export const getChunkArray = (array, size) => {
  const chunkedArr = []
  for (let i = 0; i < array.length; i += size) {
    chunkedArr.push(array.slice(i, i + size))
  }
  return chunkedArr
}
